import { buildEditorConfig } from './editor/config/editorConfig';
// @ts-expect-error not typed
import { start } from 'ContentEditorUI/UniversalApplication';
import userInfo from 'hub-http/userInfo';
import { renderRoot } from 'quartz-core/client';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { isUngatedForKnowledgeBaseV3_1 } from './auth/utils/authUtils';
import createStandardI18nProvider from 'I18n/init/providers/createStandardI18nProvider';
import { initAppTranslations } from 'I18n/init/setup/AppInit';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import registerAllData from 'I18n/init/register/lazy/registerAllData';
import UIApplication from 'UIComponents/app/UIApplication';
import { jsx as _jsx } from "react/jsx-runtime";
userInfo().then(userInfoData => {
  const standardI18nProvider = createStandardI18nProvider();
  const langAvailable = initAppTranslations([standardI18nProvider.register(lang), registerAllData(standardI18nProvider)]);
  standardI18nProvider.setLocale({
    locale: userInfoData.user.locale,
    langEnabled: userInfoData.user.lang_enabled,
    timezone: userInfoData.portal.timezone
  });
  langAvailable.then(() => {
    if (isUngatedForKnowledgeBaseV3_1(userInfoData.gates)) {
      start(buildEditorConfig(userInfoData));
    } else {
      renderRoot( /*#__PURE__*/_jsx(UIApplication, {
        name: "knowledge-base-editor-ui",
        children: /*#__PURE__*/_jsx(ErrorMessage, {
          type: "404"
        })
      }));
    }
  }).catch(() => {
    renderRoot( /*#__PURE__*/_jsx(UIApplication, {
      name: "knowledge-base-editor-ui",
      children: /*#__PURE__*/_jsx(ErrorMessage, {
        type: "badRequest"
      })
    }));
  });
}).catch(() => {
  renderRoot( /*#__PURE__*/_jsx(UIApplication, {
    name: "knowledge-base-editor-ui",
    children: /*#__PURE__*/_jsx("p", {
      children: "Something went wrong"
    })
  }));
});